import { render, staticRenderFns } from "./EventLinkingForm.vue?vue&type=template&id=2b71a8d7&scoped=true&"
import script from "./EventLinkingForm.vue?vue&type=script&lang=js&"
export * from "./EventLinkingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b71a8d7",
  null
  
)

export default component.exports